<template>
    <div>
        <a class="btn-sm btn-orange text-white" @click="$bvModal.show($id('richiesta_contatto'))">{{button}}</a>
        <b-modal size="lg" :title="$t('richiesta_contatto.modal.title')" :id="$id('richiesta_contatto')"
                 ref="richiesta_contatto" @ok="sendRequest">
            <div class="row">
                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('richiesta_contatto.modal.name')}}</label>
                    <b-form-input v-model="ticket.name" v-validate="'required|min:2|max:16'" data-vv-name="name"
                                  :placeholder="$t('richiesta_contatto.modal.name')"></b-form-input>
                    <span v-show="errors.has('name')" class="error">{{ errors.first('name') }}</span>
                </div>

                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('richiesta_contatto.modal.surname')}}</label>
                    <b-form-input v-model="ticket.surname" v-validate="'required|min:2|max:16'" data-vv-name="surname"
                                  :placeholder="$t('richiesta_contatto.modal.surname')"></b-form-input>
                    <span v-show="errors.has('surname')" class="error">{{ errors.first('surname') }}</span>
                </div>

                <div class="col-md-12 mt-3">
                    <label class="text-uppercase small text-dark pl-2">{{$t('richiesta_contatto.modal.email_address')}}</label>
                    <b-form-input class="mb-2" v-model="ticket.email" v-validate="'required|email'" data-vv-name="email"
                                  :placeholder="$t('richiesta_contatto.modal.email_address')"></b-form-input>
                    <span v-show="errors.has('email')" class="error">{{ errors.first('email') }}</span>

                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('richiesta_contatto.modal.phone_number')}}</label>
                    <b-form-input v-model="ticket.phone" v-validate="'min:5|max:15'" data-vv-name="phone"
                                  :placeholder="$t('richiesta_contatto.modal.phone_number')"></b-form-input>
                    <span v-show="errors.has('phone')" class="error">{{ errors.first('phone') }}</span>


                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('richiesta_contatto.modal.subject')}}</label>
                    <b-form-input v-model="ticket.subject" v-validate="'required|min:8|max:80'" data-vv-name="subject"
                                  :placeholder="$t('richiesta_contatto.modal.subject')"></b-form-input>
                    <span v-show="errors.has('subject')" class="error">{{ errors.first('subject') }}</span>


                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('richiesta_contatto.modal.message.title')}}</label>
                    <b-form-textarea v-model="ticket.message" v-validate="'required|min:10'" data-vv-name="message"
                                     :placeholder="$t('richiesta_contatto.modal.message.placeholder')"></b-form-textarea>
                    <span v-show="errors.has('message')" class="error">{{ errors.first('message') }}</span>

                    <b-form-checkbox v-model="ticket.check_privacy" v-validate="'required'" data-vv-name="check_privacy">{{$t('richiesta_contatto.fields.check_privacy')}}</b-form-checkbox>
                    <span v-show="errors.has('check_privacy')" class="error">{{ errors.first('check_privacy') }}</span>

                    <vue-recaptcha :sitekey="site_key" :loadRecaptchaScript="true" @verify="onCaptchaVerified"
                                   @expired="onCaptchaExpired" size="invisible" ref="recaptcha"></vue-recaptcha>

                    <span v-show="errors.has('message')" class="error">{{ errors.first('message') }}</span>
                </div>
            </div>

        </b-modal>

    </div>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha'

    export default {
        name: 'RichiestaContatto',
        props: [
            'button',
            'subject'
        ],
        components: {VueRecaptcha},
        data() {
            return {
                ticket: {
                    check_privacy: false,
                    name: '',
                    surname: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: '',
                    fullname: '',
                    token: '',
                    topic: 0
                }, sending: false
            }
        },
        computed: {
            site_key() {
                return process.env.VUE_APP_PUBLIC_RECACPHA
            }
        },
        mounted() {
            this.ticket.subject = this.subject
        },
        methods: {
            sendRequest(evt) {
                evt.preventDefault()
                if (!this.ticket.check_privacy) {
                    alert(this.$t('richiesta_contatto.alert.check_privacy'))
                    return false
                }
                this.$store.commit('loading', true)
                if (this.ticket.token === '') {
                    this.sending = true
                    this.$refs.recaptcha.execute()
                    return
                }
                this.sendWithToken()
            }, onCaptchaVerified(ret) {
                this.ticket.token = ret
                this.$refs.recaptcha.reset()
                if (this.sending)
                    this.sendWithToken()
            }, onCaptchaExpired() {
                this.ticket.token = ''
            }, async sendWithToken() {
                this.sending = false
                this.ticket.fullname = this.ticket.name + ' ' + this.ticket.surname
                if (this.ticket.phone)
                this.ticket.message += `

Numero di telefono: ${this.ticket.phone}`
                this.ticket.message += `

Autorizzo TDS al trattamento dei miei dati al solo fine di gestire questa richiesta
                `

                let data = await this.$http.post(this.$store.getters.tds_api + '/ticket/', this.ticket)
                this.ticket.token = ''
                if (data.status === 201) {
                    this.$notify({type: 'alert-success', text: this.$t('richiesta_contatto.alert.sent')})
                    this.$refs.richiesta_contatto.hide()
                    this.ticket.name = ''
                    this.ticket.surname = ''
                    this.ticket.email = ''
                    this.ticket.subject = ''
                    this.ticket.message = ''
                    this.ticket.phone = ''
                    this.ticket.fullname = ''
                    this.ticket.check_privacy = false
                } else {
                    this.$notify({type: 'alert-danger', text: this.$t('richiesta_contatto.alert.error')})
                }
                this.$store.commit('loading', false)
            }
        }
    }
</script>

<style scoped>

</style>
